/**
 * @generated SignedSource<<753b4af62770489fe65857b22300d290>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomeUser$data = {
  readonly accessibleBrands: ReadonlyArray<{
    readonly id: string;
    readonly metaAdAccounts: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly updatedAt: any;
  }>;
  readonly " $fragmentType": "HomeUser";
};
export type HomeUser$key = {
  readonly " $data"?: HomeUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"HomeUser">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomeUser",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Brand",
      "kind": "LinkedField",
      "name": "accessibleBrands",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MetaAdAccount",
          "kind": "LinkedField",
          "name": "metaAdAccounts",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "5bd7be7672dfa27189d2af23728f6e6b";

export default node;
